module.exports = __webpack_public_path__ + "static/img/200106.bcee2210.png";